<template>
  <Validator label="" :v="v" input>
    <div class="custom-input">
      <div
        :class="{
          'outline-block': true,
          'outline-block--focus': inputFocus,
          'outline-border-error': v.$invalid && v.$dirty || validation
        }">
        <the-mask
          type="text"
          :class="{ errorBorder: (v.$invalid && v.$dirty) || validation, 'outline-input': true }"
          :disabled="disabled"
          :readonly="readonly"
          :required="required"
          :placeholder="placeholder"
          :mask="mask"
          :masked="masked"
          v-model="valueMask"
          @input.native="$emit('input', retornoValor)"
          @change.native="$emit('change')"
          @focus.native="onFocus"
          @blur.native="onBlur"
          @keyup.native="$emit('keyup')"
          ref="themask" ></the-mask>
          <div
            :class="{
              'outline-label' : true,
              'outline-label-up': (value != '' && value != null) || inputFocus,
              'outline--focus': inputFocus,
              'outline-error': v.$invalid && v.$dirty
            }">
            {{ `${label}${(typeof this.v.$params['required'] != 'undefined')? '*' : ''}` }}
          </div>
          <div class="outline-disabled"></div>
      </div>
    </div>
  </Validator>
</template>

<script>
import { TheMask } from 'vue-the-mask';
import Validator from './Valitador.vue';

export default {
  inheritAttrs: false,
  nome: 'InputMask',
  components: {
    Validator,
    TheMask,
  },
  data() {
    return {
      retornoValor: '',
    };
  },
  props: {
    label: String,
    placeholder: String,
    value: [String, Number],
    mask: {
      type: [String, Array],
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
    validation: {
      type: Boolean,
      default: false,
    },
    masked: {
      type: Boolean,
      default: false,
    },
    v: {
      type: Object,
      default() {
        return {
          $invalid: false,
          $dirty: false,
          $params: [],
          $touch: () => {},
        };
      },
    },
  },
  data() {
    return {
      inputFocus: false,
    };
  },
  watch: {
    value(newVal, oldVal) {
      this.$refs.themask.lastValue = oldVal;
    },
  },
  computed: {
    valueMask: {
      get() {
        return this.value;
      },
      set(val) {
        this.retornoValor = val;
      },
    },
  },
  methods: {
    onFocus() {
      this.inputFocus = true;
      this.$emit('focus');
    },
    onBlur() {
      this.v.$touch();
      this.inputFocus = false;
      this.$emit('blur');
    },
    maxlength() {
      if (typeof this.v.$params.maxLength === 'undefined') { return ''; }

      return this.v.$params.maxLength.max;
    },
  },
};
</script>

<style lang="scss">
@import '@/assets/css/input.scss';
</style>
